import { ethers } from 'ethers'
import { Contract } from 'ethers'
import { ERC721_MIN_ABI } from './abi'

/**
 * The token ids a wallet holds in one licence collection.
 *
 * The collections are not enumerable and their ids are unix timestamps, not a
 * sequence, so they cannot be guessed or derived from a licence record — the
 * platform stores no licence-to-token mapping at all. These two calls are the
 * only way to answer "which licences does this wallet hold", which is what a
 * seller has to choose from before anything can be listed.
 */
export async function readOwnedLicenceTokenIds(params: {
  nft: string
  owner: string
  provider: ethers.providers.Provider
}): Promise<string[]> {
  const c = new Contract(
    params.nft,
    ERC721_MIN_ABI as unknown as ethers.ContractInterface,
    params.provider
  )
  const amount: ethers.BigNumber = await c.getNodesAmountByOwner(params.owner)
  const count = amount.toNumber()
  if (count === 0) return []

  const ids = await Promise.all(
    Array.from({ length: count }, (_, i) =>
      c
        .ownerNodesIds(params.owner, i)
        .then((id: ethers.BigNumber) => id.toString())
        .catch(() => null)
    )
  )
  // A failed index must not hide the tokens that did resolve.
  return ids.filter((id): id is string => id !== null)
}
